import axios from 'axios';

export default class HttpHelper {
    public static baseURL = '/portal-api';

    public static addToken(token: string) {
        axios.defaults.headers.common['Authorization'] = token;
    }

    public static get(url: string, data: any = {}, headers: any = {}): Promise<any> {
        return this.request('get', url, data, {}, headers);
    }

    public static put(url: string, data: any = {}, headers: any = {}): Promise<any> {
        return this.request('put', url, {}, data, headers);
    }

    public static post(url: string, data: any = {}, headers: any = {}): Promise<any> {
        return this.request('post', url, {}, data, headers);
    }

    public static delete(url: string, data: any = {}, headers: any = {}): Promise<any> {
        return this.request('delete', url, {}, data, headers);
    }

    public static request(method: string, url: string, params: any = {}, data: any = {}, headers: any = {}): Promise<any> {
        return new Promise((resolve, reject) => {
            axios.request({
                url: url.indexOf('http') === 0 ? url : `${this.baseURL}${url}`,
                method,
                params,
                data,
                headers
            }).then((res) => {
                resolve(res.data);
            }).catch((err) => {
                reject(err.response.data || { code: 4000000, message: '访问服务失败' });
            });
        });
    }

}